import PrimaryModal from 'components/common/PrimaryModal/PrimaryModal';
import { InlineWidget } from 'react-calendly';
import { useEffect, useState } from 'react';
import CaFlag from 'assets/flags/CaFlag';
import AuFlag from 'assets/flags/AuFlag';
import * as S from './CalendarModal.styled';

type Props = {
    userEmail: string;
    userFirstname: string;
    userLastname: string;
    scheduleUrl: string;
    country: string;
    open: boolean;
    isQualifiedBothCountries: boolean;
    onClose: () => void;
    handleCanada: () => void;
    handleAustralia: () => void;
    superAdminId: number;
    handleCalendlySchedule: (id: number) => void;
};

const CalendarModal = ({
    open,
    onClose,
    userEmail,
    userFirstname,
    userLastname,
    scheduleUrl,
    country,
    isQualifiedBothCountries,
    handleCanada,
    handleAustralia,
    superAdminId,
    handleCalendlySchedule,
}: Props) => {
    const initialWidth = () => {
        if (window.innerWidth <= 575) {
            return '35';
        }
        if (window.innerWidth > 575 && window.innerWidth <= 1028) {
            return '40';
        }
        if (window.innerWidth > 1028) {
            return '50';
        }
    };
    const initialHeight = () => {
        if (window.innerWidth <= 575) {
            return '25';
        }
        if (window.innerWidth > 575 && window.innerWidth <= 1028) {
            return '30';
        }
        if (window.innerWidth > 1028) {
            return '40';
        }
    };
    const [width, setWidth] = useState(initialWidth());
    const [height, setHeight] = useState(initialHeight());

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 767) {
                setWidth('35');
                setHeight('25');
            }
            if (window.innerWidth > 767 && window.innerWidth <= 1028) {
                setWidth('40');
                setHeight('30');
            }
            if (window.innerWidth > 1028) {
                setWidth('50');
                setHeight('40');
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        handleCalendlySchedule(superAdminId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [superAdminId]);

    return (
        <PrimaryModal
            open={open}
            onClose={onClose}
            maxWidth="none"
            width="90vw"
            padding="none"
            modalStyle={{ zIndex: '10000' }}
            style={{
                // minHeight: '80vh',
                marginTop: '2rem',
                marginBottom: '4rem',
            }}
        >
            <S.Calendar>
                <S.AIRecommended>
                    Next Step: Pick an expert{' '}
                    <span style={{ whiteSpace: 'nowrap' }}>consultation slot:</span>
                </S.AIRecommended>
                <div hidden={!isQualifiedBothCountries}>
                    <S.SelectCountryContainer>
                        <S.SelectCountry>Select Country:</S.SelectCountry>
                        <S.SelectedContainer selected={country === 'Australia'}>
                            <S.Button onClick={handleAustralia} selected={country === 'Australia'}>
                                <S.ButtonContainer selected={country === 'Australia'}>
                                    <AuFlag width={width} height={height} />
                                </S.ButtonContainer>
                            </S.Button>
                            <S.Word hidden={country !== 'Australia'}>AUS</S.Word>
                        </S.SelectedContainer>
                        <S.SelectedContainer selected={country === 'Canada'}>
                            <S.Button onClick={handleCanada} selected={country === 'Canada'}>
                                <S.ButtonContainer selected={country === 'Canada'}>
                                    <CaFlag width={width} height={height} />
                                </S.ButtonContainer>
                            </S.Button>
                            <S.Word hidden={country !== 'Canada'}>CAN</S.Word>
                        </S.SelectedContainer>
                    </S.SelectCountryContainer>
                </div>

                <InlineWidget
                    styles={{
                        height: '60vh',
                        width: '100%',
                        marginBottom: '2rem',
                        maxWidth: 'none',
                    }}
                    pageSettings={{ hideGdprBanner: true }}
                    utm={{ utmContent: userEmail }}
                    prefill={{
                        email: userEmail,
                        firstName: userFirstname,
                        lastName: userLastname,
                        name: userFirstname + ' ' + userLastname,
                    }}
                    url={scheduleUrl}
                />
            </S.Calendar>
        </PrimaryModal>
    );
};

export default CalendarModal;
